import ApiService from '@zola-helpers/client/dist/es/http/api';
import {
  MessageStatsView,
  BasePaginationViewListInquiryView,
} from '@zola/svc-marketplace-ts-types';

export function getUnreadCounts(): Promise<MessageStatsView> {
  return ApiService.get(`/web-marketplace-api/v1/inquiry/unread-count`);
}

export function getInquiryList(): Promise<BasePaginationViewListInquiryView> {
  return ApiService.post(`/web-marketplace-api/v1/inquiry/account/list`);
}
